import Reveal from '@/components/base/Reveal';
import { topicWall } from '@/mocks/home';

export default function TopicWall() {
  return (
    <section id="topics" className="bg-background-50">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <Reveal>
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 text-secondary-700 text-xs md:text-sm font-bold tracking-wide">
              <i className="ri-price-tag-3-line"></i>
              话题墙
            </span>
            <h2 className="mt-3 font-heading font-black text-2xl md:text-4xl text-foreground-950 tracking-tight">
              黑料福利每日热议话题墙
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              这里按近 24 小时的讨论热度排序，数字是当前话题下的讨论条数。标签越热，说明大家聊得越起劲。
            </p>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-9 flex flex-wrap gap-3">
            {topicWall.map((topic) => (
              <a
                key={topic.name}
                href="#latest"
                className={`cursor-pointer group inline-flex items-center gap-2.5 px-4 py-2.5 rounded-full border transition-colors whitespace-nowrap ${
                  topic.hot
                    ? 'bg-primary-500 border-primary-500 text-background-50 hover:bg-primary-600'
                    : 'bg-background-100 border-background-200 text-foreground-800 hover:border-secondary-300 hover:bg-secondary-50'
                }`}
              >
                <span className="text-sm font-medium">{topic.name}</span>
                <span
                  className={`text-xs font-bold px-2 py-0.5 rounded-full ${
                    topic.hot
                      ? 'bg-background-50/25 text-background-50'
                      : 'bg-background-200 text-foreground-600 group-hover:bg-secondary-100 group-hover:text-secondary-800'
                  }`}
                >
                  {topic.count}
                </span>
              </a>
            ))}
          </div>
        </Reveal>

        <Reveal delay={200}>
          <div className="mt-9 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            <div className="bg-background-100 border border-background-200 rounded-lg p-5">
              <span className="w-11 h-11 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                <i className="ri-add-circle-line text-2xl"></i>
              </span>
              <h3 className="mt-4 font-heading font-bold text-base md:text-lg text-foreground-950">新建一个话题</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                没看到你想聊的？自己开一个话题，等热度上来了它就会出现在上方墙面上。
              </p>
            </div>
            <div className="bg-background-100 border border-background-200 rounded-lg p-5">
              <span className="w-11 h-11 rounded-md bg-accent-100 text-accent-800 flex items-center justify-center">
                <i className="ri-line-chart-line text-2xl"></i>
              </span>
              <h3 className="mt-4 font-heading font-bold text-base md:text-lg text-foreground-950">话题热度每小时刷新</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                排序不是拍脑袋定的，热度数据每小时更新一次，昨天的话题今天也可能重新冒上来。
              </p>
            </div>
            <div className="bg-background-100 border border-background-200 rounded-lg p-5">
              <span className="w-11 h-11 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center">
                <i className="ri-bookmark-3-line text-2xl"></i>
              </span>
              <h3 className="mt-4 font-heading font-bold text-base md:text-lg text-foreground-950">收藏常逛的话题</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                把感兴趣的话题钉在墙面上，下次打开首页直接看它们的更新，不用再翻半天。
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}